// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * MobileHeader — collapsing header layout.
 *
 * TOP section: position:fixed, always visible.
 *   Default state  → logo on the left, search+globe on the right
 *   Collapsed state (.is-scrolled) → logo hidden, transport tabs on the left, search/support/account on the right
 * BOTTOM section (tabs): normal document flow, scrolls away naturally.
 * A spacer div fills the top section's height so content starts below it.
 *
 * Brand background: Figma 2349:46305 — Primary/yovo-red-400 + travel pattern.
 * One .yovo-mobile-header-hero layer (spacer + tabs + red tail) paints a single
 * background-size:cover canvas. Top bar is transparent at rest so pattern shows
 * through; .is-scrolled uses solid var(--yovo-brand-red) (#CF2048) when tabs scroll away.
 */

.yovo-mobile-header-shell {
  width: 100%;
  display: contents;
}

@media (min-width: 900px) {
  .yovo-mobile-header-shell {
    display: none;
  }
}

/* Shared Figma brand surface — pre-composited pattern on --yovo-brand-red (#cf2048) */
.yovo-mobile-header-brand-surface {
  background-color: var(--yovo-brand-red);
      /* Image URL is set in public/index.html so the phone-sized WebP can be preloaded
         before this stylesheet. */
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
}

/*
 * Single hero canvas: spacer + tabs + red tail share one cover scale.
 * Top bar stays transparent at rest so this layer shows through behind the logo row.
 */
.yovo-mobile-header-hero {
  position: relative;
  z-index: 1;
  width: 100%;
  overflow: hidden;
  border-radius: 0 0 clamp(28px, 9vw, 40px) clamp(28px, 9vw, 40px);
}

/* ===== Top bar — fixed, always visible ===== */
.yovo-mobile-header-top {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: env(safe-area-inset-top);
  padding-left: clamp(0.75rem, 4vw, 1rem);
  padding-right: clamp(0.75rem, 4vw, 1rem);
  padding-top: calc(env(safe-area-inset-top) + clamp(0.5rem, 2vw, 0.75rem));
  padding-bottom: clamp(0.5rem, 2vw, 0.75rem);
  box-sizing: border-box;
  overflow: hidden;
  background: transparent;
}

/* Collapsed: solid brand red, no logo, tabs on the left, actions on the right (Figma Primary/yovo-red-400) */
.yovo-mobile-header-top.is-scrolled {
  gap: 0.5rem;
  padding-top: calc(env(safe-area-inset-top) + clamp(0.25rem, 1vw, 0.375rem));
  padding-bottom: clamp(0.25rem, 1vw, 0.375rem);
  background: var(--yovo-brand-red);
}

/* ===== Logo — shown at rest, hidden once the bar collapses ===== */
.yovo-mobile-header-top-default {
  display: flex;
  align-items: center;
  min-width: 0;
}
.yovo-mobile-header-top.is-scrolled .yovo-mobile-header-top-default {
  display: none;
}

/* ===== Transport tabs — hidden at rest, on the left after scroll ===== */
.yovo-mobile-header-top-collapsed {
  display: none;
  align-items: center;
  gap: 0.25rem;
}
/* 36px targets around 24px icons, so 8px of flex gap reads as 20px between glyphs. */
.yovo-mobile-header-top.is-scrolled .yovo-mobile-header-top-collapsed {
  display: flex;
  gap: 8px;
}

/* ===== Top-bar spacer: pushes content below the fixed top bar =====
   Height matches .yovo-mobile-header-top before JS measures it:
   safe area + top padding + 44px icon row + bottom padding. */
.yovo-mobile-header-top-spacer {
  width: 100%;
  height: calc(
    env(safe-area-inset-top, 0px)
    + clamp(0.5rem, 2vw, 0.75rem)
    + 2.75rem
    + clamp(0.5rem, 2vw, 0.75rem)
  );
  visibility: hidden;
  pointer-events: none;
  flex-shrink: 0;
}

/* ===== Tabs section — normal flow, scrolls away with the page ===== */
.yovo-mobile-header-tabs-wrap {
  position: relative;
  /* Below form card (z-index 2); tab pills stay on top via .yovo-mobile-header-tabs-row */
  z-index: 1;
  width: 100%;
  overflow: visible;
}

/* Tab pills above overlapping search card */
.yovo-mobile-header-tabs-row {
  position: relative;
  z-index: 3;
}

/* ===== Right-side icons group in top bar ===== */
.yovo-mobile-header-top-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: clamp(0.0625rem, 0.5vw, 0.125rem);
  flex-shrink: 0;
}

/* ===== Min 44×44px tap targets (Apple HIG) ===== */
.yovo-mobile-header-icon-btn {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2.75rem;
  min-height: 2.75rem;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
  color: inherit;
}

.yovo-mobile-header-search-img {
  width: 1.375rem;
  height: 1.375rem;
  display: block;
  flex-shrink: 0;
  filter: brightness(0) invert(1);
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/styles/MobileHeader.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;EAaE;;AAEF;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,sFAAsF;AACtF;EACE,uCAAuC;MACnC;kCAC4B;EAChC,sBAAsB;EACtB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;;;EAGE;AACF;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,gEAAgE;AAClE;;AAEA,gDAAgD;AAChD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qCAAqC;EACrC,uCAAuC;EACvC,wCAAwC;EACxC,yEAAyE;EACzE,2CAA2C;EAC3C,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,6GAA6G;AAC7G;EACE,WAAW;EACX,2EAA2E;EAC3E,6CAA6C;EAC7C,iCAAiC;AACnC;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;AACf;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA,qFAAqF;AACrF;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;8DAE8D;AAC9D;EACE,WAAW;EACX;;;;;GAKC;EACD,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA,uEAAuE;AACvE;EACE,kBAAkB;EAClB,wFAAwF;EACxF,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,+BAA+B;EAC/B,oBAAoB;AACtB","sourcesContent":["/**\n * MobileHeader — collapsing header layout.\n *\n * TOP section: position:fixed, always visible.\n *   Default state  → logo on the left, search+globe on the right\n *   Collapsed state (.is-scrolled) → logo hidden, transport tabs on the left, search/support/account on the right\n * BOTTOM section (tabs): normal document flow, scrolls away naturally.\n * A spacer div fills the top section's height so content starts below it.\n *\n * Brand background: Figma 2349:46305 — Primary/yovo-red-400 + travel pattern.\n * One .yovo-mobile-header-hero layer (spacer + tabs + red tail) paints a single\n * background-size:cover canvas. Top bar is transparent at rest so pattern shows\n * through; .is-scrolled uses solid var(--yovo-brand-red) (#CF2048) when tabs scroll away.\n */\n\n.yovo-mobile-header-shell {\n  width: 100%;\n  display: contents;\n}\n\n@media (min-width: 900px) {\n  .yovo-mobile-header-shell {\n    display: none;\n  }\n}\n\n/* Shared Figma brand surface — pre-composited pattern on --yovo-brand-red (#cf2048) */\n.yovo-mobile-header-brand-surface {\n  background-color: var(--yovo-brand-red);\n      /* Image URL is set in public/index.html so the phone-sized WebP can be preloaded\n         before this stylesheet. */\n  background-size: cover;\n  background-position: center top;\n  background-repeat: no-repeat;\n}\n\n/*\n * Single hero canvas: spacer + tabs + red tail share one cover scale.\n * Top bar stays transparent at rest so this layer shows through behind the logo row.\n */\n.yovo-mobile-header-hero {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  overflow: hidden;\n  border-radius: 0 0 clamp(28px, 9vw, 40px) clamp(28px, 9vw, 40px);\n}\n\n/* ===== Top bar — fixed, always visible ===== */\n.yovo-mobile-header-top {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1100;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-top: env(safe-area-inset-top);\n  padding-left: clamp(0.75rem, 4vw, 1rem);\n  padding-right: clamp(0.75rem, 4vw, 1rem);\n  padding-top: calc(env(safe-area-inset-top) + clamp(0.5rem, 2vw, 0.75rem));\n  padding-bottom: clamp(0.5rem, 2vw, 0.75rem);\n  box-sizing: border-box;\n  overflow: hidden;\n  background: transparent;\n}\n\n/* Collapsed: solid brand red, no logo, tabs on the left, actions on the right (Figma Primary/yovo-red-400) */\n.yovo-mobile-header-top.is-scrolled {\n  gap: 0.5rem;\n  padding-top: calc(env(safe-area-inset-top) + clamp(0.25rem, 1vw, 0.375rem));\n  padding-bottom: clamp(0.25rem, 1vw, 0.375rem);\n  background: var(--yovo-brand-red);\n}\n\n/* ===== Logo — shown at rest, hidden once the bar collapses ===== */\n.yovo-mobile-header-top-default {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n}\n.yovo-mobile-header-top.is-scrolled .yovo-mobile-header-top-default {\n  display: none;\n}\n\n/* ===== Transport tabs — hidden at rest, on the left after scroll ===== */\n.yovo-mobile-header-top-collapsed {\n  display: none;\n  align-items: center;\n  gap: 0.25rem;\n}\n/* 36px targets around 24px icons, so 8px of flex gap reads as 20px between glyphs. */\n.yovo-mobile-header-top.is-scrolled .yovo-mobile-header-top-collapsed {\n  display: flex;\n  gap: 8px;\n}\n\n/* ===== Top-bar spacer: pushes content below the fixed top bar =====\n   Height matches .yovo-mobile-header-top before JS measures it:\n   safe area + top padding + 44px icon row + bottom padding. */\n.yovo-mobile-header-top-spacer {\n  width: 100%;\n  height: calc(\n    env(safe-area-inset-top, 0px)\n    + clamp(0.5rem, 2vw, 0.75rem)\n    + 2.75rem\n    + clamp(0.5rem, 2vw, 0.75rem)\n  );\n  visibility: hidden;\n  pointer-events: none;\n  flex-shrink: 0;\n}\n\n/* ===== Tabs section — normal flow, scrolls away with the page ===== */\n.yovo-mobile-header-tabs-wrap {\n  position: relative;\n  /* Below form card (z-index 2); tab pills stay on top via .yovo-mobile-header-tabs-row */\n  z-index: 1;\n  width: 100%;\n  overflow: visible;\n}\n\n/* Tab pills above overlapping search card */\n.yovo-mobile-header-tabs-row {\n  position: relative;\n  z-index: 3;\n}\n\n/* ===== Right-side icons group in top bar ===== */\n.yovo-mobile-header-top-actions {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: clamp(0.0625rem, 0.5vw, 0.125rem);\n  flex-shrink: 0;\n}\n\n/* ===== Min 44×44px tap targets (Apple HIG) ===== */\n.yovo-mobile-header-icon-btn {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 2.75rem;\n  min-height: 2.75rem;\n  -webkit-tap-highlight-color: transparent;\n  touch-action: manipulation;\n  color: inherit;\n}\n\n.yovo-mobile-header-search-img {\n  width: 1.375rem;\n  height: 1.375rem;\n  display: block;\n  flex-shrink: 0;\n  filter: brightness(0) invert(1);\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
